import React from 'react'
import './Projects.css'
import img6 from '../Assets/teachingImg2.jpg'
import img12 from '../Assets/healthImg4.jpeg'
import img13 from '../Assets/microfinanceImg1.webp'
import img17 from '../Assets/cropFarming.jpeg'



const Projects = () => {
  return (
    <div className='ProjectsContainer'>
      <div className='ProjectsheroSection'>
        <div className='ProjectsheroOverlay'>
          <h1 className='OurProjectsText'>Our Projects</h1>
        </div>
      </div>
      <div className='farmingsection'>
      <p className='introductorytext'>
        We've carried out a range of life-changing projects across farming, education, healthcare, 
        and micro-finance—each one aimed at improving everyday lives in underserved communities. 
      </p>

      {/* farming section */}
      <div class="farming-section">
        <div class="farming-content">
          <div class="farming-image">
            <img src={img17} alt='Farming Image' className=''/>
          </div>
          <div className="farming-text">
            <h2>Farming</h2>
            <p>
              Volunteer Impact Initiative undertakes projects which focus on plant (crop) and animal 
              (poultry and rabbit) farming at the Mephibosheth Training Centre in the Central Region of Ghana. 
              The farm plays a crucial role in providing food for the residents of the training centre, 
              which supports physically and mentally challenged children and adults. Located in Gomoa Ankamu, 
              the Mephibosheth Training Centre is dedicated to offering education, care, and opportunities 
              for growth to individuals with disabilities. Volunteers are encouraged to bring their knowledge, 
              experience, and skills in farming to contribute to the success of the project. Creativity and 
              initiative are also valued as key components in driving positive outcomes.
            </p>

            <a href="/Farming" className=""><div className='viewMoreDiv'>View More</div>  </a>
          </div>
        </div>
      </div>

      {/* teaching section */}
      <div class="teaching-section">
          <div class="teaching-content">
            <div class="teaching-image">
              <img src={img6} alt='Teaching Image' className=''/>
            </div>
            <div class="teaching-text">
              <h2>Teaching</h2>
              <p>
                Volunteer Impact Initiative undertakes projects which focus on providing educational support 
                at local schools and community learning centers in Ghana. Volunteers play a vital role in 
                enhancing the quality of education by assisting with teaching, tutoring, and classroom 
                management, particularly in under-resourced areas.
                The initiative aims to empower students by improving their literacy, numeracy, and critical thinking skills. 
                Volunteers will work alongside local teachers to deliver engaging lessons, foster a love for learning, 
                and provide individualized attention to students who need extra support.
                Creativity, patience, and adaptability are highly valued, as volunteers are encouraged to bring their unique 
                teaching methods and perspectives to create a dynamic and inclusive learning environment. 
                Whether it’s teaching English, mathematics, or arts, your contribution will make a significant impact on the 
                educational journey of these young learners. 
           
              </p>

            <a href="/Teaching" className=""> <div className='viewMoreDiv'>View More</div> </a>
            </div>
            
          </div>
      </div>


      {/* Health Section */}
      <div class="health-section">
          <div class="health-content">
            <div class="health-image">
              <img src={img12} alt='health Image' className=''/>
            </div>
            <div class="health-text">
              <h2>Health</h2>
              <p>
                Volunteer Impact Initiative undertakes projects which focuses on providing essential health 
                services and support to underserved communities in Ghana, particularly in rural and remote areas 
                where access to healthcare is limited. Volunteers will collaborate with local health professionals 
                at clinics, hospitals, and community health centers, contributing to a wide range of activities such 
                as health education, basic medical care, and patient support. The initiative aims to improve overall 
                community health through preventive care, health screenings, and education on hygiene and disease prevention. 
                Volunteers with skills in nursing, medicine, public health, or even a passion for helping others are encouraged 
                to participate. Compassion, adaptability, and a willingness to learn are key, as volunteers will be working 
                in diverse and often challenging environments. Your involvement will not only provide crucial healthcare support 
                but also help to build healthier and more resilient communities.
           
              </p>

            <a href="/Health" className=""> <div className='viewMoreDiv'>View More</div> </a>
            </div>
            
          </div>
      </div>


      {/* Microfinance Section */}
      <div class="microfinance-section">
          <div class="microfinance-content">
            <div class="microfinance-image">
              <img src={img13} alt='Microfinance Image' className=''/>
            </div>
            <div class="microfinance-text">
              <h2>MicroFinance</h2>
              <p>
                This project is dedicated to empowering women through microfinance initiatives that provide small loans and 
                financial education to women entrepreneurs in underserved communities across Ghana. 
                By offering access to capital and resources, the project aims to foster financial independence, improve living 
                standards, and support the growth of small businesses run by women. Volunteers will work closely with local women 
                to provide training in basic financial management, business planning, and savings strategies. The goal is to help 
                these women develop sustainable businesses that can lift their families out of poverty and contribute to the economic 
                development of their communities. Volunteers with skills in finance, business, education, or a passion for women's 
                empowerment are encouraged to participate. Creativity, patience, and strong communication skills are highly valued, 
                as volunteers will play a key role in guiding and inspiring these women to achieve their financial goals.
           
              </p>

            <a href="/Microfinance" className=""> <div className='viewMoreDiv'>View More</div> </a>
            </div>
            
          </div>
      </div>


    </div>
    </div>
  )
}

export default Projects